import { snapshot } from 'valtio'
import { emailRegex } from '../../../../../../shared/utils/formattingUtils'
import { FormFieldNamesEnum } from './formFieldNamesEnum'
import { proxyRefund } from './refundProxy'

export const FIELDS_REQUIRED_FOR_SUBMISSION = [
  FormFieldNamesEnum.RefundAmount
]

export const validators: { [key in FormFieldNamesEnum]?: (arg0: string) => string | null } = {
  [FormFieldNamesEnum.RefundAmount]: val => {
    if (!val) { return 'Required' }
    const { transaction } = snapshot(proxyRefund)
    if (val.length < 0) { return 'Must be greater than 0' }
    if (parseFloat(val) < 0) { return 'Must be greater than 0' }
    if (transaction?.remainingAmountCents) {
      if (parseFloat(val) > transaction?.remainingAmountCents) {
        return 'Amount cannot be greater than the remaining refund amount'
      }
    }
    return null
  },
  [FormFieldNamesEnum.Email]: val => {
    if (!val) { return null }//They are not forced to enter an email
    if (!emailRegex.test(val)) { return 'Invalid email format' }

    return null
  }
}
